module.exports = __webpack_public_path__ + "img/Bluetooth.141f806b.svg";